import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = { policyId: Number, versionId: Number, domainId: Number }

  declare readonly policyIdValue: number
  declare readonly versionIdValue: number
  declare readonly domainIdValue: number

  connect (): void {
  }

  async handleClick (event: Event): Promise<void> {
    event.preventDefault()

    try {
      const formData = new FormData()
      formData.append('policy_document_version[domain_id]', this.domainIdValue.toString())

      const response = await fetch(`/policies/${this.policyIdValue}/versions/${this.versionIdValue}/clear_newly_added_indicator`, {
        method: 'PATCH',
        headers: {
          'X-CSRF-Token': this.getCsrfToken(),
          Accept: 'text/vnd.turbo-stream.html'
        },
        body: formData
      })

      if (response.ok) {
        const html = await response.text()
        const Turbo = (window as any).Turbo
        Turbo.renderStreamMessage(html)
      } else {
        console.error('Failed to clear newly added indicators')
      }
    } catch (error) {
      console.error('Error clearing newly added indicators:', error)
    }
  }

  stopPropagation (event: Event): void {
    event.stopPropagation()
  }

  private getCsrfToken (): string {
    const tokenElement = document.querySelector('meta[name="csrf-token"]') as HTMLMetaElement
    return tokenElement?.content ?? ''
  }
}
